<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="グループ 12637">
      <path
        data-name="パス 5084"
        d="M582.75 544a.749.749 0 0 0 .75-.75v-3.75h3.75a.75.75 0 0 0 0-1.5h-4.5a.749.749 0 0 0-.75.75v4.5a.749.749 0 0 0 .75.75z"
        transform="translate(-580.5 -535.002)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5085"
        d="M598.25 547.752h-3v-3a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3v3a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5z"
        transform="translate(-582.5 -536.502)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5086"
        d="M607.25 538h-4.5a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0v-4.5a.749.749 0 0 0-.75-.75z"
        transform="translate(-585.5 -535.002)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5087"
        d="M587.25 558.5h-3.75v-3.75a.75.75 0 0 0-1.5 0v4.5a.749.749 0 0 0 .75.75h4.5a.75.75 0 0 0 0-1.5z"
        transform="translate(-580.5 -539.002)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5088"
        d="M607.25 554a.749.749 0 0 0-.75.75v3.75h-3.75a.75.75 0 0 0 0 1.5h4.5a.749.749 0 0 0 .75-.75v-4.5a.749.749 0 0 0-.75-.75z"
        transform="translate(-585.5 -539.002)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AutofocusSVG',
  props: {
    size: {
      type: String,
      default: '24px',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    color: {
      type: String,
      default: '#989898',
    },
  },
};
</script>
